export default function () {
  const self = this,
    role = self.$store.state.user.role

  if (role === 'Comprador') {
    self.$router.push('orders')
  }

  if (self.$store.state.user.roles.includes('ROLE_ADMIN')) {
    self.$router.push('highlight_report')
  }

  self.loadPosts()
  self.updatePresence()
}
